import { LicenseName } from "@/data/license.data";
import { LimiterWithUniqueLimits } from "@/services/license/license-limiters/base-limiters/limiter-with-unique-limits";

export abstract class ServiceUsingCountLimiter extends LimiterWithUniqueLimits {
  isUsingCountExpired = async (
    userId: string,
    usingCount: number,
    license: LicenseName,
  ): Promise<boolean> => {
    const limit = await this.getLimit(userId, license);
    return usingCount >= limit;
  };

  isLimitedUsingCount = async (userId: string, license: LicenseName) => {
    const count = await this.getLimit(userId, license);
    return count === Infinity;
  };
}
